<template>
  <div class="flex flex-col">
    <div class="relative flex-1">
      <div class="absolute inset-0 flex justify-center">
        <div v-if="selectedUnits.length < 1" class="flex items-center justify-center w-full h-full">
          Choose any unit below by tapping or dragging into this area to start compare.
        </div>
        <draggable
          v-else
          v-model="selectedUnits"
          group="units"
          item-key="name"
          filter=".ignore"
          class="flex justify-center w-full p-8 pb-4 divide-x xl:p-12 xl:pb-6"
          @start="drag=true"
          @end="drag=false"
        >
          <template #item="{ element }">
            <div class="relative w-1/2 px-3 lg:w-1/3 2xl:w-1/4 xl:px-4">
              <div class="relative flex flex-col h-full p-8 mx-6">
                <div class="relative mb-4">
                  <h1 class="text-2xl font-bold uppercase xl:text-4xl text-primary-500">
                    TYPE {{ element.name }}
                  </h1>
                  <h2 class="text-lg font-medium uppercase">
                    {{ element.type.name }}
                  </h2>
                  <h3 class="">
                    {{ element.area }} sq.m.
                  </h3>

                  <a class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 m-0 text-white rounded-full stroke-current bg-secondary-500 ignore" @click="remove(element)">
                    <x-icon />
                  </a>
                </div>

                <div class="relative flex items-center justify-center flex-1 w-40 mx-auto xl:w-64">
                  <!-- <img :src="`plans/units/0/${element.name}.png`" class="object-contain w-full h-full transition-all duration-200 transform max-h-64"> -->
                  <unit-image :name="element.name" class="flex items-center justify-center w-full h-full max-h-64" />
                </div>
              </div>
            </div>
          </template>
        </draggable>
      </div>
    </div>

    <unit-list :items="units" :selected="selectedUnits" class="flex-shrink-0" @select="toggle" />

    <div class="flex flex-no-wrap flex-shrink-0 py-4 mx-auto space-x-4 overflow-x-auto whitespace-no-wrap fhd:max-w-none">
      <label v-for="type in collections.types" :key="type.id" class="cursor-pointer">
        <input v-model="selectedType" type="radio" :value="type.id" class="hidden">
        <div class="relative px-3 py-1 transition-all duration-200">
          {{ type.name }}
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { XIcon } from '@zhuowenli/vue-feather-icons'

import UnitImage from '@/components/UnitImage.vue'
import UnitList from '@/components/UnitList.vue'

export default {
  name: 'Compare',
  components: {
    Draggable,
    XIcon,
    UnitImage,
    UnitList,
  },
  props: {
    name: {
      type: String,
      require: false,
      default: '',
    },
  },
  data () {
    return {
      collections: {
        units: require('@/assets/data/units.json'),
        types: require('@/assets/data/unit_types.json'),
      },

      selectedType: 1,
      selectedUnit: null,

      maxItems: () => {
        const width = window.innerWidth

        if (width >= 1536) { return 4 }
        if (width >= 1024) { return 3 }

        return Math.floor(width / 340)
      },

      selectedUnits: [],
    }
  },
  computed: {
    units () {
      return this.collections.units.filter(({ typeId }) => typeId === this.selectedType)
    },
    unit () {
      const unit = this.collections.units.find(({ name }) => name === this.selectedUnit)

      if (!unit) return null

      return {
        ...unit,
        type: this.collections.types.find(({ id }) => id === unit.typeId),
      }
    },
  },
  mounted () {
    this.selectedType = this.collections.types[0].id
  },
  methods: {
    toggle (unit) {
      if (this.isSelected(unit)) {
        this.remove(unit)
      } else {
        this.add(unit)
      }
    },
    add (unit) {
      if (this.selectedUnits.length < this.maxItems()) {
        this.selectedUnits.push({
          ...unit,
          type: this.collections.types.find(({ id }) => id === unit.typeId),
        })
      }
    },
    remove (unit) {
      this.selectedUnits = this.selectedUnits.filter(item => item.name !== unit.name)
    },
    isSelected (unit) {
      return this.selectedUnits.find(item => item.name === unit.name)
    },
  },
}
</script>

<style lang="postcss" scoped>
input[type="radio"]:checked + div {
  @apply text-white bg-black shadow rounded-full;
}

::v-deep(.sortable-drag) {
  @apply border-0 !important;
}
</style>
